'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "closeable", "closeDisabledMessage", "draggable", "hideDefaultTooltip", "isCloseDisabled", "dragHandle", "DragHandle", "onClose", "truncate"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled, { css } from 'styled-components';
import classNames from 'classnames';
import { EERIE, KOALA, OLAF, MONOLITH } from 'HubStyleTokens/colors';
import { getComponentPropType } from '../utils/propTypes/componentProp';
import { hidden } from '../utils/propTypes/decorators';
import UICloseButton from '../button/UICloseButton';
import UIDragHandle from './UIDragHandle';
import UITooltip from '../tooltip/UITooltip';
import UITruncateString from '../text/UITruncateString';
import { setInputMetrics, setInputAppearance, setGrabCursor } from '../utils/Styles';
import { INPUT_DEFAULT_PADDING_Y, BASE_FONT_SIZE, JUPITER_LAYER } from 'HubStyleTokens/sizes';
import { rgba } from '../core/Color';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const draggingMixin = css(["", ";box-shadow:0 0 12px 0 ", ";z-index:", ";"], setGrabCursor('grabbing'), rgba(MONOLITH, 0.1), JUPITER_LAYER);
const Outer = styled.div.withConfig({
  displayName: "UIMoveableObject__Outer",
  componentId: "bdvxra-0"
})([".hs-private.hs-private.hs-private &{position:relative;", " ", ";font-size:", ";background-color:", ";}.hs-private.hs-private.hs-private ", " .private-moveable-object + &{margin-top:12px;}"], setInputAppearance(), setInputMetrics(parseInt(INPUT_DEFAULT_PADDING_Y, 10) - 1, 26, 30), BASE_FONT_SIZE, ({
  use
}) => use === 'on-dark' ? OLAF : KOALA, ({
  isDragging
}) => isDragging && draggingMixin);
const CloseButton = styled(UICloseButton).withConfig({
  displayName: "UIMoveableObject__CloseButton",
  componentId: "bdvxra-1"
})([".hs-private.hs-private.hs-private &{top:16px;margin-right:-12px;}"]);
const TooltipAnchor = styled.span.withConfig({
  displayName: "UIMoveableObject__TooltipAnchor",
  componentId: "bdvxra-2"
})([".hs-private.hs-private.hs-private &{height:100%;position:absolute;right:0;top:0;width:30px;}"]);
export default class UIMoveableObject extends Component {
  render() {
    const _this$props = this.props,
      {
        children,
        className,
        closeable,
        closeDisabledMessage,
        draggable,
        hideDefaultTooltip,
        isCloseDisabled,
        dragHandle,
        DragHandle,
        onClose,
        truncate
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const content = truncate ? /*#__PURE__*/_jsx(UITruncateString, {
      hideDefaultTooltip: hideDefaultTooltip,
      children: children
    }) : children;
    const renderedChildren = /*#__PURE__*/_jsxs(Outer, Object.assign({}, rest, {
      className: classNames('private-moveable-object', className),
      children: [content, closeable && /*#__PURE__*/_jsx(UITooltip, {
        title: closeDisabledMessage,
        children: /*#__PURE__*/_jsx(TooltipAnchor, {
          children: /*#__PURE__*/_jsx(CloseButton, {
            color: EERIE,
            disabled: isCloseDisabled,
            onClick: onClose,
            size: "sm"
          })
        })
      })]
    }));
    if (draggable) {
      const ComputedDragHandle = dragHandle || DragHandle;
      return /*#__PURE__*/_jsx(ComputedDragHandle, {
        children: renderedChildren
      });
    }
    return renderedChildren;
  }
}
UIMoveableObject.displayName = 'UIMoveableObject';
UIMoveableObject.defaultProps = {
  closeable: true,
  draggable: true,
  hideDefaultTooltip: false,
  isCloseDisabled: false,
  isDragging: false,
  DragHandle: UIDragHandle,
  truncate: true,
  use: 'default'
};
UIMoveableObject.propTypes = {
  children: PropTypes.node.isRequired,
  closeable: PropTypes.bool.isRequired,
  closeDisabledMessage: PropTypes.string,
  draggable: PropTypes.bool.isRequired,
  hideDefaultTooltip: PropTypes.bool,
  isCloseDisabled: PropTypes.bool.isRequired,
  isDragging: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  dragHandle: hidden(getComponentPropType(UIDragHandle)),
  DragHandle: getComponentPropType(UIDragHandle).isRequired,
  truncate: hidden(PropTypes.bool),
  use: PropTypes.oneOf(['default', 'on-dark'])
};